import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useResource, useGrid, useModal, useStore, useToast, usePopup, usePage } from "@/comn/hooks"; // hook
import { BASE, URLS, APIS, SF_CSTM_SRCH, SG_CSTM_LIST } from "@/tra/tancis/ptli/usr/cstm/services/PtliCstmMgmtService";

/*
 * Customs Management List
 * !== 세관 관리 목록 ==!
 */
export const PTLI0901001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0016" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Customs Search !== 세관 검색 ==!
        cstmSrch: useForm({
            defaultSchema: SF_CSTM_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Customs List !== 세관 목록 ==!
        cstmList: useGrid({
            defaultSchema: SG_CSTM_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Repacking Item Application List !== 세관 목록 조회 ==!
        getCstmList: useFetch({
            api: (page = grid.cstmList.page) => {
                return APIS.getCstmList(form.cstmSrch.getValues(), page, grid.cstmList.size);
            },
            enabled: comnUtils.isEmpty(form.cstmSrch.errors) && form.cstmSrch.isSubmitted,
            key: [grid.cstmList.page, grid.cstmList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cstmSrch.getValues(),
                    page: grid.cstmList.page,
                    size: grid.cstmList.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Repacking Item Application List !== 세관 목록 조회 ==!
        getCstmList: () => {
            form.cstmSrch.handleSubmit(
                (data) => {
                    grid.cstmList.setPage(0);
                    fetch.getCstmList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        grid_CstmDtl: {
            cell: {
                cstmNm: (props: any) => {
                    const { rowValues, value } = props;
                    return <Link to={`${URLS.ptli0901004q}/${rowValues.cstmOfceCd}`}>{value}</Link>;
                },
            },
        },
    };

    useEffect(() => {
        handler.getCstmList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmSrch.schema.cstmOfceCd}></Group.Control>
                            <Group.Control {...form.cstmSrch.schema.cstmTpCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmSrch.schema.cstmNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.cstmSrch.reset();
                                }}
                            >
                                {t("B_RESET")}
                            </Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.getCstmList();
                                }}
                            >
                                {t("B_SRCH")}
                            </Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.cstmList.grid}
                            data={fetch.getCstmList.data?.cstmList}
                            render={render.grid_CstmDtl}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.ptli0901002s);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
